import type { SVGProps } from 'react';

export function ConfettiCardBg(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='307'
      height='92'
      viewBox='0 0 307 92'
      fill='none'
      preserveAspectRatio='xMidYMid slice'
      aria-hidden
      {...props}
    >
      <g opacity='.15'>
        <rect
          width='6.55922'
          height='23.1226'
          transform='matrix(-0.93039 0.366571 -0.51076 -0.859724 30.0073 105.196)'
          fill='#FEDF89'
        />
        <rect
          width='6.71944'
          height='22.3744'
          transform='matrix(-0.98221 -0.187788 0.277007 -0.960868 205.973 61.5095)'
          fill='#FEDF89'
        />
        <rect
          width='6.71944'
          height='22.3744'
          transform='matrix(0.98221 -0.187788 -0.277007 -0.960868 79.3643 11.824)'
          fill='#FEDF89'
        />
        <rect
          width='7.50223'
          height='23.6519'
          transform='matrix(0.69117 0.722692 -0.844466 0.53561 217.355 79.7972)'
          fill='#EB9AAD'
        />
        <rect
          width='7.50223'
          height='23.6519'
          transform='matrix(-0.69117 0.722692 0.844466 0.53561 67.9805 30.1121)'
          fill='#EB9AAD'
        />
        <rect
          width='6.87288'
          height='25.3147'
          transform='matrix(-0.0239439 0.999713 -0.999874 -0.0158818 271.155 38.1863)'
          fill='#A0DFFA'
        />
        <rect
          width='7.69546'
          height='23.0864'
          transform='matrix(0.775407 -0.631462 0.775407 0.631462 262.932 84.6549)'
          fill='#B6D1A3'
        />
        <rect
          width='7.69546'
          height='23.0864'
          transform='matrix(-0.775407 -0.631462 -0.775407 0.631462 22.4062 34.9711)'
          fill='#B6D1A3'
        />
        <rect
          width='7.69546'
          height='23.0864'
          transform='matrix(0.775407 -0.631462 0.775407 0.631462 232.425 -9.19934)'
          fill='#EB9AAD'
        />
        <rect
          width='7.99202'
          height='22.161'
          transform='matrix(0.879612 0.475691 0.63197 -0.774993 160.689 72.6375)'
          fill='#B6D1A3'
        />
        <rect
          width='8.42597'
          height='20.6637'
          transform='matrix(-0.997003 -0.0773672 0.116218 -0.993224 166.254 23.6833)'
          fill='#EB9AAD'
        />
      </g>
    </svg>
  );
}
